module.exports = __webpack_public_path__ + "static/media/dashboard_on@2x.7ed5277b.svg";